import {
  types,
  PublishingLocationsActionType,
  IPublishingLocations,
} from '../types/publishingLocations'

export const initialState: IPublishingLocations = {
  isLoading: false,
  list: [],
}

export const publishingLocations = (
  state = initialState,
  action: PublishingLocationsActionType
): IPublishingLocations => {
  switch (action.type) {
    case types.GET_PUBLISHING_LOCATIONS__STARTED:
      return { ...initialState, isLoading: true }
    case types.GET_PUBLISHING_LOCATIONS__SUCCESS:
      return { ...state, isLoading: false, list: action.list || [] }
    case types.GET_PUBLISHING_LOCATIONS__FAILURE:
      return { ...state, isLoading: false, message: action.message }
    default:
      return state
  }
}
